import { render } from "./HeroiconsOutlineReply.vue?vue&type=template&id=7c4be9ac"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineReply.vue"]])

export default __exports__